import React from 'react';
import Text from './base';

const Subtitle = props => (
  <Text defaultTag="h2" variant="subtitle" {...props} />
);

export default Subtitle;
